import styled from '@emotion/styled'
import { theme } from 'j-comps'
import { Card } from '@mui/material'
import CanvaImage from './CanvaImage'
import { connect } from 'react-redux'
import CreateNew from './CreateNew'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ResultImages = styled.div`
  display: grid;
  grid-gap: ${theme.spacing.medium} ${theme.spacing.medium};
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  background-color: white;
  padding: ${theme.spacing.medium};
`

const Results = ({ designs }) => {
  return (
    <Container>
      {designs && (
        <ResultImages>
          {designs.map((design, i) => (
            <Card key={i} raised>
              <CanvaImage design={design} />
            </Card>
          ))}
          <Card raised>
            <CreateNew />
          </Card>
        </ResultImages>
      )}
    </Container>
  )
}

const mapStateToProps = (state) => ({
  designs: state.designs,
})

export default connect(mapStateToProps)(Results)
